export default "__VITE_ASSET__FK_iQq$3__"